import BusinessLogicException from "exceptions/BusinessLogicException";
import type { Setup } from "features/setups/types";
import SetupValueRegistry from "./registry";
import { StringSetupValue } from "./String";

export class SetupValueFactory {
    public static make(registry = SetupValueRegistry) {
        return new this(registry);
    }

    private constructor(
        private readonly registry = SetupValueRegistry
    ) { };

    public init(initialValues: Setup<string>) {
        const { valueType } = initialValues;

        try {
            if (!this.registry.has(valueType)) {
                throw new BusinessLogicException(
                    `SetupValue for ${valueType} has not been registered`,
                    initialValues
                );
            }

            const [, SetupValueConstructor] = this.registry.get(valueType)!;

            return new SetupValueConstructor(initialValues);
        } catch (exception) {
            if (exception instanceof BusinessLogicException) {
                return new StringSetupValue(initialValues);
            }

            throw exception;
        }
    }
};

export default SetupValueFactory;
